export const DELIVERY_ORDER_STATUSES = Object.freeze({
  unassigned: {
    label: 'Unassigned',
    color: 'var(--fp-colors-orange-950)',
    allowedStates: ['canceled', 'archived'],
  },
  scheduled: {
    label: 'Scheduled',
    color: 'var(--fp-colors-gray-440)',
    allowedStates: ['started', 'completed', 'departed', 'canceled', 'archived', 'ready_to_sync'],
  },
  ready_to_sync: {
    label: 'Ready to Sync',
    color: 'var(--fp-colors-blue-400)',
    allowedStates: ['started', 'completed', 'departed', 'canceled', 'archived', 'ready_to_sync'],
  },
  departed: {
    label: 'Departed',
    color: 'var(--fp-colors-brown-50)',
    allowedStates: ['started', 'completed', 'scheduled', 'archived'],
  },
  started: {
    label: 'Started',
    color: 'var(--fp-colors-yellow-50)',
    allowedStates: ['completed', 'departed', 'scheduled', 'archived'],
  },
  completed: {
    label: 'Completed',
    color: 'var(--fp-colors-green-650)',
    allowedStates: ['verified', 'archived'],
  },
  verified: {
    label: 'Verified',
    color: 'var(--fp-colors-purple-350)',
    allowedStates: ['completed', 'archived'],
  },
  accounting_synced: {
    label: 'Synced with Accounting',
    color: 'var(--fp-colors-purple-350)',
    allowedStates: ['verified', 'archived'],
  },
  blocked: {
    label: 'Blocked',
    color: 'red',
    allowedStates: ['scheduled', 'unassigned', 'archived'],
  },
  canceled: {
    label: 'Canceled',
    color: 'var(--fp-colors-purple-275)',
    allowedStates: ['unassigned', 'scheduled', 'archived'],
  },
  billed: {
    label: 'Billed',
    color: 'var(--fp-colors-green-650)',
    allowedStates: [],
  },
  limit_exceeded: {
    label: 'Limit Exceeded',
    color: 'var(--fp-colors-orange-550)',
    allowedStates: ['unassigned', 'scheduled', 'archived'],
  },
  credited: {
    label: 'Credited',
    color: 'var(--fp-colors-brown-50)',
    allowedStates: [],
  },
  created: {
    label: 'Created',
    bgColor: 'yellow.50',
    color: 'white',
    allowedStates: ['unassigned', 'scheduled', 'archived'],
    bgColorForList: 'yellow.50',
    colorForList: 'black',
  },
  generated: {
    label: 'Generated',
    bgColor: 'green.600',
    color: 'white',
    allowedStates: ['unassigned', 'scheduled', 'archived'],
    bgColorForList: 'green.600',
    colorForList: 'white',
  },
  synced: {
    label: 'Synced',
    bgColor: 'purple.350',
    color: 'white',
    allowedStates: ['unassigned', 'scheduled', 'archived'],
    bgColorForList: 'purple.350',
    colorForList: 'white',
  },
  skipped: {
    label: 'Skipped',
    color: 'var(--fp-colors-orange-100)',
    allowedStates: ['unassigned', 'archived'],
  },
  archived: {
    label: 'Archived',
    color: 'var(--fp-colors-red-500)',
    allowedStates: [],
  },
});

export const LOADING_ORDER_STATUSES = Object.freeze({
  unassigned: {
    label: 'Unassigned',
    color: 'var(--fp-colors-orange-950)',
    allowedStates: ['canceled', 'archived'],
  },
  blocked: {
    label: 'Blocked',
    color: 'red',
    allowedStates: ['scheduled', 'unassigned', 'archived'],
  },
  scheduled: {
    label: 'Scheduled',
    color: 'var(--fp-colors-gray-440)',
    allowedStates: ['started', 'completed', 'departed', 'canceled', 'archived'],
  },
  departed: {
    label: 'Departed',
    color: 'var(--fp-colors-brown-50)',
    allowedStates: ['started', 'completed', 'scheduled', 'archived'],
  },
  started: {
    label: 'Started',
    color: 'var(--fp-colors-yellow-50)',
    allowedStates: ['completed', 'departed', 'scheduled', 'archived'],
  },
  completed: {
    label: 'Completed',
    color: 'var(--fp-colors-green-650)',
    allowedStates: ['verified', 'archived'],
  },
  verified: {
    label: 'Verified',
    color: 'var(--fp-colors-purple-350)',
    allowedStates: ['completed', 'archived'],
  },
  accounting_synced: {
    label: 'Synced with Accounting',
    color: 'var(--fp-colors-purple-350)',
    allowedStates: ['verified', 'archived'],
  },
  canceled: {
    label: 'Canceled',
    color: 'var(--fp-colors-purple-275)',
    allowedStates: ['unassigned', 'scheduled', 'archived'],
  },
  skipped: {
    label: 'Skipped',
    color: 'var(--fp-colors-orange-100)',
    allowedStates: ['unassigned', 'archived'],
  },
  archived: {
    label: 'Archived',
    color: 'var(--fp-colors-red-500)',
    allowedStates: [],
  },
  packing: {
    label: 'Packing',
    color: 'var(--fp-colors-orange-1000)',
    allowedStates: ['started', 'completed', 'departed', 'canceled', 'archived', 'ready_to_sync'],
  },
  packed: {
    label: 'Packed',
    color: 'var(--fp-colors-orange-1000)',
    allowedStates: ['started', 'completed', 'departed', 'canceled', 'archived', 'ready_to_sync'],
  },
});

export const TRANSFER_ORDER_STATUSES = Object.freeze({
  unassigned: {
    label: 'Unassigned',
    color: 'var(--fp-colors-orange-950)',
    allowedStates: ['canceled', 'archived'],
  },
  scheduled: {
    label: 'Scheduled',
    color: 'var(--fp-colors-gray-440)',
    allowedStates: [
      'started',
      'completed',
      'departed',
      'scheduled',
      'canceled',
      'archived',
      'ready_to_sync',
    ],
  },
  completed: {
    label: 'Completed',
    color: 'var(--fp-colors-green-650)',
    allowedStates: ['verified', 'archived', 'ready_to_sync'],
  },
  verified: {
    label: 'Verified',
    color: 'var(--fp-colors-purple-350)',
    allowedStates: ['completed', 'archived'],
  },
  accounting_synced: {
    label: 'Synced with Accounting',
    color: 'var(--fp-colors-purple-350)',
    allowedStates: ['verified', 'archived'],
  },
  canceled: {
    label: 'Canceled',
    color: 'var(--fp-colors-purple-275)',
    allowedStates: ['unassigned', 'archived', 'ready_to_sync'],
  },
  skipped: {
    label: 'Skipped',
    color: 'var(--fp-colors-orange-100)',
    allowedStates: ['unassigned', 'archived'],
  },
  archived: {
    label: 'Archived',
    color: 'var(--fp-colors-red-500)',
    allowedStates: [],
  },
  ready_to_sync: {
    label: 'Ready to Sync',
    color: 'var(--fp-colors-blue-400)',
    allowedStates: ['completed', 'canceled', 'archived'],
  },
});

export const ORDER_GROUP_STATUSES = Object.freeze({
  unassigned: { label: 'Unassigned', color: 'var(--fp-colors-orange-950)' },
  scheduled: { label: 'Scheduled', color: 'var(--fp-colors-gray-440)' },
  started: { label: 'Started', color: 'var(--fp-colors-yellow-50)' },
  completed: { label: 'Completed', color: 'var(--fp-colors-green-650)' },
  archived: { label: 'Archived', color: 'var(--fp-colors-red-500)' },
  ready_to_sync: { label: 'Ready To Sync', color: 'var(--fp-colors-blue-500)' },
  packing: { label: 'Packing', color: 'var(--fp-colors-orange-1000)' },
  packed: { label: 'Packed', color: 'var(--fp-colors-orange-1000)' },
});

export const SHIFT_STATUSES = Object.freeze({
  active: { label: 'Active', color: 'var(--fp-colors-gray-255)', allowedStates: ['completed'] },
  completed: { label: 'Completed', color: 'var(--fp-colors-green-650)' },
  review1: { label: 'Review 1', color: 'var(--fp-colors-blue-930)' },
  review2: { label: 'Review 2', color: 'var(--fp-colors-purple-150)' },
  review3: { label: 'Review 3', color: 'var(--fp-colors-yellow-100)' },
  sync_to_accounting: { label: 'Sync to Accounting', color: 'var(--fp-colors-orange-990)' },
  archived: { label: 'Archived', color: 'var(--fp-colors-red-475)' },
});

export default Object.freeze({
  delivery_order: DELIVERY_ORDER_STATUSES,
  loading_order: LOADING_ORDER_STATUSES,
  transfer_order: TRANSFER_ORDER_STATUSES,
  order_group: ORDER_GROUP_STATUSES,
  shift_status: SHIFT_STATUSES,
});
